// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

// 用户管理
import user from '@/views/user/user';

import sensitiveCheck from "../views/user/sensitiveCheck";

// 纸条管理
import Paper from '@/views/paper/paper';

// 订单管理
import Order from '@/views/pay/Order';

// 基础管理
import Variable from '@/views/system/Variable';
import VipConfig from '@/views/system/VipConfig';

import Data from '@/views/data/data';

// 数据可视化
import statistics from '@/views/charts/statistics';


// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        },{
          path: '/user/paper',
          name: '纸条管理',
          component: Paper,
          meta: {
            requireAuth: true
          }
        }, {
            path: '/user/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        },{
          path: '/user/sensitiveCheck',
          name: '敏感数据审核',
          component: sensitiveCheck,
          meta: {
            requireAuth: true
          }
        }, {
          path: '/data/data',
          name: '数据中心',
          component: Data,
          meta: {
            requireAuth: true
          }
        },{
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
          path: '/system/vipConfig',
          name: '系统环境变量',
          component: VipConfig,
          meta: {
            requireAuth: true
          }
        },  {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js